// extracted by mini-css-extract-plugin
module.exports = {"text":"_DmL2rx7q"};